module.exports = __webpack_public_path__ + "img/17-03_Focusing on Priorities.d5d7b67e.svg";